import { APITypesV1 } from "@cur8/api-client";
import { Visit } from "@cur8/rich-entity";

/**
 * Read scan state from the visit data for a given scan type (e.g. "skin", "cardio", "tci")
 * @returns ImmutableScanState (or undefined if the scan type is not found in the visit's immutableScansPerformed object)
 */

type ScanType = "skin" | "cardio" | "tci" | "ecg";

export function readScanStateFromVisit(
  scanType: ScanType,
  visit?: Visit
): APITypesV1.ImmutableScanState | undefined {
  if (visit?.immutableScansPerformed == null) {
    return undefined;
  }

  const scanTypeKey = Object.keys(visit.immutableScansPerformed).find((key) =>
    key.includes(scanType)
  );

  return visit.immutableScansPerformed[scanTypeKey ?? ""]?.resultState;
}
